// // fixedHeader.js
function checkSizeHeader() {
    if (window_width > 991) return false;
    scroll_top = $(this).scrollTop();
    let max = 50;
    // header scroll
    if (scroll_top > max && !headerSmall) {
        header.addClass("small");
        headerSmall = true;
    };
    if (scroll_top <= max && headerSmall) {
        header.removeClass("small");
        headerSmall = false;
    };
};

// let timer;
// let headerBG = false;
// function scrollHeader() {
//     if (window_width > 991) return false;
//     // console.log($(window).scrollTop())

//     if ($(window).scrollTop() > 50 && !headerBG) {
//         headerBG = true;
//         $("header").addClass("bg").css({
//             background: ''
//         });
//     }
//     if (headerBG && ($(window).scrollTop() < 50 || $(window).scrollTop() <= 0)) {
//         headerBG = false;
//         $("header").removeClass("bg").css({
//             background: 'transparent'
//         })
//     }
//     if ($(window).scrollTop() < 0) {
//         headerBG = false;
//         $("header").removeClass("bg").css({
//             background: 'rgba(0,0,0,0.00001)'
//         });
//         // clearTimeout(timer)
//         // timer = setTimeout(() => {
//         //     alert($("header").hasClass('bg'))
//         // }, 250);
//     }
// }

$(document).ready(function () {
    // header init
    header = $('header');
    header.addClass("transition0s")
    $(window).scroll(checkSizeHeader)
    checkSizeHeader();
    setTimeout(() => { header.removeClass("transition0s"); }, 1000);
    // header init
});

    // if (window_width <= 991) {
    //     $(window).on("scroll.header", scrollHeader)
    //     scrollHeader();
    // }
// // fixedHeader.js